<template>
  <div>
    <bar-chart :data="datoGrafica2"
               suffix="%"
               :download="true"
    />
  </div>
</template>


<script>
import {mapState} from 'vuex';

export default {
  name: 'graficasItem',
  data() {
    return {
      colors: ['#106b21', '#fce903', '#ce0018']
    };
  },
  computed: {
    ...mapState('listaChequeo', [
      'datoGrafica2',
    ]),
  },
};
</script>
